/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateStocklocationDto } from '../models/work-create-stocklocation-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkStocklocation } from '../models/work-stocklocation';
import { WorkUpdateStocklocationDto } from '../models/work-update-stocklocation-dto';

@Injectable({ providedIn: 'root' })
export class WorkStocklocationsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `stocklocationsV2ControllerGetAllDropdownOptions()` */
  static readonly StocklocationsV2ControllerGetAllDropdownOptionsPath = '/v2/stocklocations/dropdown-options';

  /**
   * Required permissions: stocklocations:read, stocklocations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerGetAllDropdownOptions$Response(
    params?: {
      withoutParents?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
      rb.query('withoutParents', params.withoutParents, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:read, stocklocations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerGetAllDropdownOptions(
    params?: {
      withoutParents?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.stocklocationsV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `stocklocationsV2ControllerGetAllStocklocations()` */
  static readonly StocklocationsV2ControllerGetAllStocklocationsPath = '/v2/stocklocations/all';

  /**
   * Required permissions: stocklocations:read, stocklocations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerGetAllStocklocations()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerGetAllStocklocations$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkStocklocation>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerGetAllStocklocationsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkStocklocation>>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:read, stocklocations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerGetAllStocklocations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerGetAllStocklocations(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkStocklocation>> {
    return this.stocklocationsV2ControllerGetAllStocklocations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkStocklocation>>): Array<WorkStocklocation> => r.body)
    );
  }

  /** Path part for operation `stocklocationsV2ControllerFindDefault()` */
  static readonly StocklocationsV2ControllerFindDefaultPath = '/v2/stocklocations/default';

  /**
   * Required permissions: stocklocations:read, stocklocations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerFindDefault()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerFindDefault$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkStocklocation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerFindDefaultPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkStocklocation>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:read, stocklocations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerFindDefault$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerFindDefault(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkStocklocation> {
    return this.stocklocationsV2ControllerFindDefault$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkStocklocation>): WorkStocklocation => r.body)
    );
  }

  /** Path part for operation `stocklocationsV2ControllerGetAllChildrenStocklocationsForId()` */
  static readonly StocklocationsV2ControllerGetAllChildrenStocklocationsForIdPath = '/v2/stocklocations/children/{id}';

  /**
   * Required permissions: stocklocations:read, stocklocations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerGetAllChildrenStocklocationsForId()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerGetAllChildrenStocklocationsForId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkStocklocation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerGetAllChildrenStocklocationsForIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkStocklocation>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:read, stocklocations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerGetAllChildrenStocklocationsForId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerGetAllChildrenStocklocationsForId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkStocklocation> {
    return this.stocklocationsV2ControllerGetAllChildrenStocklocationsForId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkStocklocation>): WorkStocklocation => r.body)
    );
  }

  /** Path part for operation `stocklocationsV2ControllerGetAllParentStocklocationsForId()` */
  static readonly StocklocationsV2ControllerGetAllParentStocklocationsForIdPath = '/v2/stocklocations/parent/{id}';

  /**
   * Required permissions: stocklocations:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerGetAllParentStocklocationsForId()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerGetAllParentStocklocationsForId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkStocklocation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerGetAllParentStocklocationsForIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkStocklocation>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerGetAllParentStocklocationsForId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerGetAllParentStocklocationsForId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkStocklocation> {
    return this.stocklocationsV2ControllerGetAllParentStocklocationsForId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkStocklocation>): WorkStocklocation => r.body)
    );
  }

  /** Path part for operation `stocklocationsV2ControllerFindAllPaginated()` */
  static readonly StocklocationsV2ControllerFindAllPaginatedPath = '/v2/stocklocations';

  /**
   * Required permissions: stocklocations:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by id query param.
     *           <p>
     *              <b>Format: </b> filter.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.id=$not:$like:John Doe&filter.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.id'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkStocklocation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'id'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.businessunitId', params['filter.businessunitId'], {});
      rb.query('filter.id', params['filter.id'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkStocklocation>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'businessunitId'?: (string | Array<string>);
        'id'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by id query param.
     *           <p>
     *              <b>Format: </b> filter.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.id=$not:$like:John Doe&filter.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.id'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkStocklocation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'id'?: (string | Array<string>);
};
};
}> {
    return this.stocklocationsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkStocklocation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'id'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkStocklocation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'id'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `stocklocationsV2ControllerCreate()` */
  static readonly StocklocationsV2ControllerCreatePath = '/v2/stocklocations';

  /**
   * Required permissions: stocklocations:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stocklocationsV2ControllerCreate$Response(
    params: {
      body: WorkCreateStocklocationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkStocklocation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkStocklocation>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stocklocationsV2ControllerCreate(
    params: {
      body: WorkCreateStocklocationDto
    },
    context?: HttpContext
  ): Observable<WorkStocklocation> {
    return this.stocklocationsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkStocklocation>): WorkStocklocation => r.body)
    );
  }

  /** Path part for operation `stocklocationsV2ControllerFindOneById()` */
  static readonly StocklocationsV2ControllerFindOneByIdPath = '/v2/stocklocations/{id}';

  /**
   * Required permissions: stocklocations:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkStocklocation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkStocklocation>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkStocklocation> {
    return this.stocklocationsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkStocklocation>): WorkStocklocation => r.body)
    );
  }

  /** Path part for operation `stocklocationsV2ControllerDelete()` */
  static readonly StocklocationsV2ControllerDeletePath = '/v2/stocklocations/{id}';

  /**
   * Required permissions: stocklocations:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stocklocationsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.stocklocationsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `stocklocationsV2ControllerUpdate()` */
  static readonly StocklocationsV2ControllerUpdatePath = '/v2/stocklocations/{id}';

  /**
   * Required permissions: stocklocations:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stocklocationsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stocklocationsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateStocklocationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkStocklocationsV2Service.StocklocationsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: stocklocations:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stocklocationsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  stocklocationsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateStocklocationDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.stocklocationsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
